import { Routes } from '@angular/router';
import { authGuard } from '../guards/auth.guard';
import { guestGuard } from '../guards/guest.guard';
import { rosterManageGuard } from '../guards/roster-manage.guard';
import { eventsManageGuard } from '../guards/events-manage.guard';

export const routes: Routes = [
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  {
    path: 'auth/login',
    loadComponent: () =>
      import('./auth/login/login.page').then((m) => m.LoginPage),
    canActivate: [guestGuard],
  },
  {
    path: 'auth/signup',
    loadComponent: () =>
      import('./auth/signup/signup.page').then((m) => m.SignupPage),
    canActivate: [guestGuard],
  },
  {
    path: 'auth/forgot-password',
    loadComponent: () =>
      import('./auth/forgot-password/forgot-password.page').then(
        (m) => m.ForgotPasswordPage
      ),
    canActivate: [guestGuard],
  },
  {
    path: 'auth/password',
    loadComponent: () =>
      import('./auth/password-login/password-login.page').then(
        (m) => m.PasswordLoginPage
      ),
    canActivate: [guestGuard],
  },
  {
    path: '',
    loadComponent: () => import('./tabs/tabs.page').then((m) => m.TabsPage),
    canActivate: [authGuard],
    children: [
      {
        path: 'home',
        loadComponent: () => import('./home/home.page').then((m) => m.HomePage),
      },
      {
        path: 'roster',
        loadComponent: () =>
          import('./team/roster/roster.page').then((m) => m.RosterPage),
      },
      {
        path: 'member-detail/:id',
        loadComponent: () =>
          import('./member-detail/member-detail.component').then(
            (m) => m.MemberDetailComponent
          ),
      },
      {
        path: 'schedule',
        loadComponent: () =>
          import('./team/schedule/schedule.page').then((m) => m.SchedulePage),
      },
      {
        path: 'teams',
        loadComponent: () =>
          import('./organization/teams/teams.page').then((m) => m.OrgTeamsPage),
      },
      {
        path: 'org-schedule',
        loadComponent: () =>
          import('./organization/schedule-view/schedule-view.page').then(
            (m) => m.ScheduleViewPage
          ),
      },
      {
        path: 'standings',
        loadComponent: () =>
          import('./league/standings/standings.page').then(
            (m) => m.StandingsPage
          ),
      },
      {
        path: 'messages',
        loadComponent: () =>
          import('./messages/messages.page').then((m) => m.MessagesPage),
      },
      {
        path: 'messages/compose',
        loadComponent: () =>
          import('./compose-message/compose-message.page').then(
            (m) => m.ComposeMessagePage
          ),
      },
      {
        path: 'messages/:id',
        loadComponent: () =>
          import('./message-thread/message-thread.page').then(
            (m) => m.MessageThreadPage
          ),
      },
      {
        path: 'more-options',
        loadComponent: () =>
          import('./more-options/more-options.page').then(
            (m) => m.MoreOptionsPage
          ),
      },
      { path: '', redirectTo: 'home', pathMatch: 'full' },
    ],
  },
  {
    path: 'onboarding',
    loadComponent: () =>
      import('./onboarding/onboarding.page').then((m) => m.OnboardingPage),
    canActivate: [authGuard],
  },
  {
    path: 'invitations',
    loadComponent: () =>
      import('./invitations/invitations.page').then((m) => m.InvitationsPage),
    canActivate: [authGuard],
  },
  {
    path: 'pending-invitations',
    loadComponent: () =>
      import('./pending-invitations/pending-invitations.page').then(
        (m) => m.PendingInvitationsPage
      ),
    canActivate: [authGuard],
  },
  {
    path: 'create-member',
    loadComponent: () =>
      import('./create-member/create-member.page').then(
        (m) => m.CreateMemberPage
      ),
    canActivate: [authGuard, rosterManageGuard],
  },
  {
    path: 'edit-member/:id',
    loadComponent: () =>
      import('./create-member/create-member.page').then(
        (m) => m.CreateMemberPage
      ),
    canActivate: [authGuard, rosterManageGuard],
  },
  {
    path: 'create-team',
    loadComponent: () =>
      import('./create-team/create-team.page').then((m) => m.CreateTeamPage),
    canActivate: [authGuard],
  },
  {
    path: 'edit-team/:id',
    loadComponent: () =>
      import('./create-team/create-team.page').then((m) => m.CreateTeamPage),
    canActivate: [authGuard],
  },
  {
    path: 'create-organization',
    loadComponent: () =>
      import('./create-organization/create-organization.page').then(
        (m) => m.CreateOrganizationPage
      ),
    canActivate: [authGuard],
  },
  {
    path: 'edit-organization/:id',
    loadComponent: () =>
      import('./create-organization/create-organization.page').then(
        (m) => m.CreateOrganizationPage
      ),
    canActivate: [authGuard],
  },
  {
    path: 'create-league',
    loadComponent: () =>
      import('./create-league/create-league.page').then(
        (m) => m.CreateLeaguePage
      ),
    canActivate: [authGuard],
  },
  {
    path: 'edit-league/:id',
    loadComponent: () =>
      import('./create-league/create-league.page').then(
        (m) => m.CreateLeaguePage
      ),
    canActivate: [authGuard],
  },
  {
    path: 'create-post',
    loadComponent: () =>
      import('./create-post/create-post.page').then((m) => m.CreatePostPage),
    canActivate: [authGuard],
  },
  {
    path: 'post/:id',
    loadComponent: () =>
      import('./post-detail/post-detail.page').then((m) => m.PostDetailPage),
    canActivate: [authGuard],
  },
  {
    path: 'schedule-import',
    loadComponent: () =>
      import('./schedule-import/schedule-import.page').then(
        (m) => m.ScheduleImportPage
      ),
    canActivate: [authGuard, eventsManageGuard],
  },
  {
    path: 'create-game',
    loadComponent: () =>
      import('./create-game/create-game.page').then((m) => m.CreateGamePage),
    canActivate: [authGuard],
  },
  {
    path: 'create-event',
    loadComponent: () =>
      import('./create-event/create-event.page').then((m) => m.CreateEventPage),
    canActivate: [authGuard],
  },
  {
    path: 'create-opponent',
    loadComponent: () =>
      import('./create-opponent/create-opponent.page').then(
        (m) => m.CreateOpponentPage
      ),
    canActivate: [authGuard],
  },
  {
    path: 'edit-opponent/:id',
    loadComponent: () =>
      import('./create-opponent/create-opponent.page').then(
        (m) => m.CreateOpponentPage
      ),
    canActivate: [authGuard],
  },
  {
    path: 'create-location',
    loadComponent: () =>
      import('./create-location/create-location.page').then(
        (m) => m.CreateLocationPage
      ),
    canActivate: [authGuard],
  },
  {
    path: 'locations',
    loadComponent: () =>
      import('./locations/locations.page').then((m) => m.LocationsPage),
    canActivate: [authGuard],
  },
  {
    path: 'profile',
    loadComponent: () =>
      import('./profile/profile.page').then((m) => m.ProfilePage),
    canActivate: [authGuard],
  },
  {
    path: 'edit-location/:id',
    loadComponent: () =>
      import('./create-location/create-location.page').then(
        (m) => m.CreateLocationPage
      ),
    canActivate: [authGuard],
  },
  {
    path: 'event/:id',
    loadComponent: () =>
      import('./event-detail/event-detail.page').then((m) => m.EventDetailPage),
    canActivate: [authGuard],
  },
  {
    path: 'game-score/:id',
    loadComponent: () =>
      import('./game-score/game-score.page').then((m) => m.GameScorePage),
    canActivate: [authGuard],
  },
  {
    path: 'organization/schedule-wizard',
    loadComponent: () =>
      import('./organization/schedule-wizard/schedule-wizard.page').then(
        (m) => m.ScheduleWizardPage
      ),
    canActivate: [authGuard],
  },
  {
    path: 'organization/schedule',
    loadComponent: () =>
      import('./organization/schedule-view/schedule-view.page').then(
        (m) => m.ScheduleViewPage
      ),
    canActivate: [authGuard],
  },
];
